
const FormTabs = ({ tabs, activeTabIndex, setActiveTabIndex }) => {
  if (!tabs || tabs.length <= 1) return null;

  return (
    <div className="flex gap-4 px-4 pb-2">
      {tabs.map((tab, i) => (
        <button
          key={tab.id || i}
          onClick={() => setActiveTabIndex(i)}
          className={`px-6 py-2 rounded-full text-sm font-medium ${
            i === activeTabIndex ? "bg-gray-900 text-white" : "bg-gray-100 text-gray-800"
          }`}
        >
          {tab.label || `Page ${i + 1}`}
        </button>
      ))}
    </div>
  );
};

export default FormTabs;
